import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';

import { installErrorReport } from './utils/errorReport';

import * as serviceWorker from './serviceWorker';
import App from './client/App';

import './styles/fonts.css';
import './styles/reset.css';
import './styles/index.css';
import './styles/new_note.css';

// 2026-10-10: Sentry 는 한도 초과(429·403)로 기록이 안 돼 끄고, 화면 오류를 이용 기록(/api/track)으로 보낸다 (a-qa-sentry)
installErrorReport();

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
